import {useNavigate} from "@tanstack/react-router"
import {useEffect} from "react"
import useToasts from "@/library/toasts/_hook.toast"
import DocumentTitle from "@/components/page-meta/page-title"

export default function NotFound404() {
    const navigate = useNavigate()
    const {toast} = useToasts()

    useEffect(() => {
        //navigate({
        //    to: "/"
        //}).then(() => {
        //    toast("404_not_found", {
        //        category: "global",
        //        type: "error",
        //        autoClose: true,
        //        title: "Ikke funnet",
        //        message: "Innholdet du lette etter ble ikke funnet..."
        //    })
        //})
    }, [])

    return <>

        <p>Fant ikke :(</p>
    </>
}
